import { useEffect } from "react";
import { useNavigate, useRouteError } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Button from "@/lib/components/ui/Button";

import styles from "./not-found.module.scss";

const isChunkLoadError = (error: unknown): boolean => {
  if (!(error instanceof Error)) return false;
  const msg = error.message;

  return (
    /Loading chunk/i.test(msg) ||
    /Loading CSS chunk/i.test(msg) ||
    /Failed to fetch dynamically imported module/i.test(msg) ||
    /Failed to load module script/i.test(msg)
  );
};

const NotFound = (): JSX.Element => {
  const { t } = useTranslation("translation");
  const tx = (key: string) => t(key as any);
  const navigate = useNavigate();
  const error = useRouteError();

  useEffect(() => {
    if (isChunkLoadError(error)) {
      window.location.reload();
    }
  }, [error]);

  return (
    <div className={styles.container}>
      <span className={styles.errorCode}>404</span>
      <h1 className={styles.title}>{tx("notFound404")}</h1>
      <p className={styles.description}>{tx("notFoundDescription")}</p>
      <p className={styles.hint}>{tx("refreshPage")}</p>
      <div className={styles.actions}>
        <Button
          variant="primary"
          size="l"
          iconName="home"
          onClick={() => navigate("/")}
        >
          {tx("goToHome")}
        </Button>
        <Button
          variant="secondary"
          size="l"
          iconName="sync"
          onClick={() => window.location.reload()}
        >
          {tx("refresh")}
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
